
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"stroke",attrs:{"d":"M9 7C8.81786 7 8.64709 7.0487 8.5 7.13378C8.24855 7.27924 8.06631 7.53104 8.01479 7.82769L6 18L1 17M9 7L7.81258 14.1094L11 16.5M9 7C9.41105 7 9.76418 7.24801 9.9179 7.60256M11 23V16.5M11 16.5V16L9 14L9.97961 8.20189C9.99298 8.13669 10 8.06916 10 8C10 7.85877 9.97072 7.72437 9.9179 7.60256M9.9179 7.60256C10.4453 9.06837 12.4 12 16 12","stroke":"#262D33","stroke-width":"2","stroke-linecap":"round"}}),_c('circle',{staticClass:"fill",attrs:{"cx":"10.5","cy":"3.5","r":"2","fill":"#30373D"}}),_c('path',{staticClass:"stroke",attrs:{"d":"M14 8.5V14.5H22V8.5M14 8.5L15.5 7H18M14 8.5H18M22 8.5L20.5 7H18M22 8.5H18M18 8.5V7","stroke":"#262D33","stroke-linecap":"round"}}),_c('path',{staticClass:"stroke",attrs:{"d":"M4.5 9H0.5","stroke":"#262D33","stroke-linecap":"round"}}),_c('path',{staticClass:"stroke",attrs:{"d":"M4.5 13H0.5","stroke":"#262D33","stroke-linecap":"round"}}),_c('path',{staticClass:"stroke",attrs:{"d":"M5 11H2","stroke":"#262D33","stroke-linecap":"round"}})])
          )
        }
      }
    